// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const ShieldGeneric = ({ height, width }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 83 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <path
      d="M81.1192 17.5921C68.0992 11.8655 55.0825 6.0788 42.0692 0.232132C41.7757 0.079621 41.4499 0 41.1192 0C40.7885 0 40.4626 0.079621 40.1692 0.232132C27.1359 6.0788 14.0825 11.8755 1.00919 17.6221C0.693042 17.7084 0.418309 17.9052 0.234836 18.1768C0.0513625 18.4483 -0.0286957 18.7766 0.00918708 19.1021C0.00918708 28.0121 0.00918727 36.9121 0.0591873 45.8221C0.0807474 48.7423 0.31806 51.6569 0.769187 54.5421C2.23495 63.7126 5.90314 72.3906 11.4592 79.8321C18.5692 89.4021 27.6492 96.2421 39.1492 99.7021C40.3911 100.102 41.7273 100.102 42.9692 99.7021C53.5957 96.5249 62.9317 90.0406 69.6192 81.1921C77.7654 70.9659 82.1786 58.2663 82.1292 45.1921V19.1921C82.1665 18.8505 82.0869 18.5064 81.9035 18.2158C81.7201 17.9252 81.4436 17.7054 81.1192 17.5921V17.5921ZM15.0692 76.1621C10.2248 69.634 7.03071 62.0313 5.75919 54.0021C5.36791 51.4705 5.1607 48.9138 5.13919 46.3521C5.05919 38.5421 5.13919 30.7321 5.13919 22.9221C5.10218 22.6382 5.16876 22.3505 5.32672 22.1117C5.48468 21.873 5.72343 21.6991 5.99919 21.6221L40.2992 6.34213C40.5406 6.22936 40.8028 6.16806 41.0692 6.16213V93.8621C40.5161 93.8554 39.9669 93.7678 39.4392 93.6021C29.6095 90.6463 21.0384 84.5125 15.0692 76.1621V76.1621Z"
      fill="#D0CDD0"
    />
  </svg>
);
ShieldGeneric.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default ShieldGeneric;
